window.CardLegendsSearch = window.CardLegendsSearch || {};

window.CardLegendsSearch.normalizeQuery = (query) => {
  const clean = String(query || '').trim().replace(/\s+/g, ' ');
  if (!clean) return '';

  const aliases = new Map([
    ['psa10', 'PSA 10'],
    ['psa-10', 'PSA 10'],
    ['pokmon', 'Pokémon'],
    ['pokemon', 'Pokémon'],
    ['one peice', 'One Piece'],
    ['onepiece', 'One Piece'],
    ['yugioh', 'Yu-Gi-Oh!'],
    ['yu gi oh', 'Yu-Gi-Oh!'],
  ]);

  const lower = clean.toLocaleLowerCase('de-DE');
  if (aliases.has(lower)) return aliases.get(lower);

  // Preserve authentic TCG codes (OP05, OP05-067, EB02-040, PRB01-106).
  // Only adjust separators or letter case when the whole query is a code.
  const code = clean.match(/^(op|st|eb|prb)[\s-]*([0-9]{1,3})(?:[\s-]+([0-9]{1,4}))?$/i);
  if (code) {
    const prefix = code[1].toUpperCase();
    const set = code[2].padStart(2, '0');
    const number = code[3] ? '-' + code[3].padStart(3, '0') : '';
    return prefix + set + number;
  }

  return clean;
};